// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideRows as RawLucideRows } from "lucide-react";
export const LucideRows = /* @__PURE__ */ createIcon(RawLucideRows, "LucideRows", 2);
